(function () {
  const sliders = [];
  const MOBILE_BREAKPOINT = 989;

  const getSliderSettings = (sliderEl, section, isMobileOnly) => {
    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 4);
    const productsPerRowMobile = Number(
      sliderEl.dataset.productsPerRowMobile || 1
    );
    const spaceBetween = Number(sliderEl.dataset.spaceBetween || 24);

    const prevBtn = section.querySelector(
      `.heading-group__navigation .heading-group__navigation-button-prev`
    );
    const nextBtn = section.querySelector(
      `.heading-group__navigation .heading-group__navigation-button-next`
    );

    const slidesPerViewMobile = productsPerRowMobile;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1200 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1360 = productsPerRow;

    const settings = {
      slidesPerView: slidesPerViewMobile,
      spaceBetween: spaceBetween / 2,
      speed: 800,
      // cssMode scrolls on .swiper-wrapper; our mobile grid-slider CSS was
      // clipping that wrapper. Transform mode matches product-recommendations.
      cssMode: !isMobileOnly,
      watchSlidesProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
    };

    if (prevBtn && nextBtn) {
      settings.navigation = {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      };
    }

    if (isMobileOnly) {
      return settings;
    }

    settings.breakpoints = {
      576: {
        slidesPerView: slidesPerView576,
        spaceBetween: spaceBetween,
      },
      990: {
        slidesPerView: slidesPerView990,
        spaceBetween: spaceBetween,
      },
      1200: {
        slidesPerView: slidesPerView1200,
        spaceBetween: spaceBetween,
      },
      1360: {
        slidesPerView: slidesPerView1360,
        spaceBetween: spaceBetween,
      },
    };

    return settings;
  };

  const initSliders = (section) => {
    const sliderEls = section.querySelectorAll(".js-popular-products-slider");

    sliderEls.forEach((sliderEl) => {
      const swiperWrapper = sliderEl.querySelector(
        ".popular-products__list--slider"
      );
      const slides = sliderEl.querySelectorAll(".popular-products__item");

      if (!swiperWrapper || !slides || !slides.length) return;
      if (sliderEl.swiper) return;

      const slider = new Swiper(
        sliderEl,
        getSliderSettings(sliderEl, section, false)
      );
      sliders.push(slider);
    });
  };

  const initMobileSliders = (section) => {
    const sliderEls = section.querySelectorAll(
      ".js-popular-products-mobile-slider"
    );
    const isMobile = window.matchMedia(
      `(max-width: ${MOBILE_BREAKPOINT}px)`
    ).matches;

    sliderEls.forEach((sliderEl) => {
      const slides = sliderEl.querySelectorAll(".popular-products__item");

      if (!slides.length) return;

      if (!isMobile) {
        if (sliderEl.swiper) {
          sliderEl.swiper.destroy(true, true);
        }
        return;
      }

      if (sliderEl.swiper) return;

      new Swiper(sliderEl, getSliderSettings(sliderEl, section, true));
    });
  };

  const destroySliders = () => {
    sliders.forEach((slider) => {
      if (typeof slider.destroy === "function") {
        slider.destroy();
      }
    });
    sliders.length = 0;
  };

  const initPopularProducts = (section) => {
    if (!section || !section?.classList.contains("popular-products-section")) {
      return;
    }

    const box = section.querySelector(".popular-products");
    if (!box) return;

    const layout = box.dataset.layout || "grid";

    if (layout === "slider") {
      initSliders(section);
    } else {
      initMobileSliders(section);
    }
  };

  initPopularProducts(document.currentScript.parentElement);

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      document.querySelectorAll(".popular-products-section").forEach((section) => {
        const box = section.querySelector(".popular-products");
        if (!box || box.dataset.layout !== "grid") return;
        if (!section.querySelector(".js-popular-products-mobile-slider")) return;

        initMobileSliders(section);
      });
    }, 150);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initPopularProducts(event.target);
  });
})();
